import LOGO from "../images/Potros.png";

export const Team__Potros = {
  name: "Potros",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#D4A017",
  teamJerseyColor: "#111111",

  // Stats
  gamesWon: 2,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,

  // ownGoalsInFavor: 18 + 54 + 47,
  // goalsScoredAgainst: 40 + 43 + 36,
  ownGoalsInFavor: 18 + 47,
  goalsScoredAgainst: 40 + 36,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
